<template>

  <el-select
    v-model="fontSize"
    class="myStyle BtnEdit  input-font__bold   padding-top-5 padding-bottom-5 padding-left-10 margin-right-10 border-radius__3"
    size="mini"
    filterable
    placeholder="-"
    @change="fontSizeChanged"
    :disabled="disabled"
  >
    <el-option  v-for="value in values" :key="value" :value="value">{{value}}</el-option>
  </el-select>
</template>

<script>
  import constants from "../../../constants";

  export default {
    name: "canvas-font-size",
    props: ["disabled"],

    data() {
      return {
        fontSize: null,
        range: [5, 20],
        values: null,
      }
    },

    created() {
      this.initValues();
    },

    methods: {
      initValues() {
        this.fontSize = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE;
        this.values = [];
        let value;
        for (value = this.range[0]; value <= this.range[1]; value++) {
          this.values.push(value);
        }
      },

      fontSizeChanged() {
        this.$emit("fontSizeChanged", this.fontSize);
      },

      setFontSize(fontSize) {
        this.fontSize = fontSize;
      }
    }
  }
</script>

<style scoped>
.myStyle{
  margin-left: 10px;
  width: 90px;
  padding: 10px;
  border: white;

}

</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/canvas-font-size.vue